export enum CalendarEventType {
  lesson,
  timeSlot,
}
